<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";

import addedit from "./addedit";
import { required } from "vuelidate/lib/validators";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";


export default {
  mixins: [Api, Sabit],
  page: {
    title: "Plan & Rapor",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    FullCalendar,
    Layout,
    PageHeader,
    addedit,
  },
  data() {
    return {
      title: "Plan & Rapor",
      items: [
        {
          text: "Anasayfa",
        },
        {
          text: "Plan & Rapor",
          active: true,
        },
      ],
      DataUpdate: "",
      AddEdit: "",
      calendarOptions: {
        buttonText: {
          today: 'Bugün',
          month: 'Ay',
          week: 'Hafta',
          day: 'Gün',
          list: 'Liste'
        },
        locale: 'tr',
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "",
        },
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          bootstrapPlugin,
          listPlugin,
        ],
        initialView: "dayGridMonth",
        themeSystem: "bootstrap",
        editable: true,
        droppable: true,
        eventResizableFromStart: true,

        dateClick: this.dateClicked,
        eventClick: this.editEvent,

        weekends: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,

        eventDidMount(info) {
          if (!info.event.extendedProps.description) return

          const tooltip = document.createElement("div")
          tooltip.innerText = info.event.extendedProps.description

          tooltip.style.position = "absolute"
          tooltip.style.zIndex = "9999"
          tooltip.style.background = "#000"
          tooltip.style.color = "#fff"
          tooltip.style.padding = "4px 8px"
          tooltip.style.borderRadius = "4px"
          tooltip.style.fontSize = "12px"
          tooltip.style.pointerEvents = "none"
          tooltip.style.display = "none"

          document.body.appendChild(tooltip)

          info.el.addEventListener("mouseenter", e => {
            tooltip.style.left = e.pageX + 10 + "px"
            tooltip.style.top = e.pageY + 10 + "px"
            tooltip.style.display = "block"
          })

          info.el.addEventListener("mousemove", e => {
            tooltip.style.left = e.pageX + 10 + "px"
            tooltip.style.top = e.pageY + 10 + "px"
          })

          info.el.addEventListener("mouseleave", () => {
            tooltip.style.display = "none"
          })
        }
      },

      currentEvents: [],
      showModal: false,
      eventModal: false,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        title: "",
        category: "",
      },
      editevent: {
        editTitle: "",
        editcategory: "",
      },
      BaslangicTarih: null
    };
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },

  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "tlpplanrapor",
        FullData: true,
        Filter: "&Personelid=" + this.TokenPersonelId,
      }).then((res) => {
        const Data = res.Data

        this.ActionsFilterGet({
          Service: "oresmitatil",
          FullData: true,
          Filter: "&Desc=",
        }).then((res2) => {
          const Data2 = res2.Data

          this.calendarEvents =
            this.transformData(Data).concat(this.transformData2(Data2))

          const calendarApi = this.$refs.fullCalendar.getApi()
          calendarApi.removeAllEvents()
          calendarApi.addEventSource(this.calendarEvents)
        })
      })
    },
transformData(data) {
  return data.flatMap(item => {
    let talepler = []
    let yapilanlar = []

    // Planlanan talepler
    try {
      talepler = item.Planlanantalepler
        ? JSON.parse(item.Planlanantalepler)
        : []
    } catch {
      talepler = []
    }

    // Yapılan talepler (STRING → JSON)
    try {
      yapilanlar = item.Yapilantalepler
        ? JSON.parse(item.Yapilantalepler)
        : []
    } catch {
      yapilanlar = []
    }

    
    // 🚫 HİÇ TALEP YOKSA → "TALEPSİZ"
    if (talepler.length === 0 && yapilanlar.length === 0) {
      return [{
        id: `empty_${item.Id}`,
        title: "Talepsiz",
        start: item.Tarih,
        allDay: true,
        classNames: ["bg-secondary"],
        extendedProps: {
          hamhali: item,
          type: "empty"
        }
      }]
    }
    
    // 🔵🔴 PLANLI TALEPLER
    const plannedEvents = talepler.map((talep, index) => {
      const talepId = item.Planlanantalepids[index]
      const isDone = yapilanlar.some(y => y.takipno === talep.takipno)

      return {
        id: `${item.Id}_${talep.takipno}`,
        title: `${talep.takipno}`,
        start: item.Tarih,
        allDay: true,
        classNames: [
          isDone ? "bg-primary" : "bg-danger"
        ],
        extendedProps: {
          description: talep.baslik,
          takipNo: talep.takipno,
          talepId,
          hamhali: item
        }
      }
    })

    // 🟢 YAPILMIŞ AMA PLANLANMAMIŞ TALEPLER
    const greenEvents = yapilanlar
      .filter(y =>
        !talepler.some(p => p.takipno === y.takipno)
      )
      .map(y => ({
        id: `green_${item.Id}_${y.takipno}`,
        title: `${y.takipno}`,
        start: item.Tarih,
        allDay: true,
        classNames: ["bg-success"],
        extendedProps: {
          description: y.baslik,
          takipNo: y.takipno,
          hamhali: item
        }
      }))

    // 🔁 BİRLEŞTİR
    return [...plannedEvents, ...greenEvents]
  })
},

    transformData2(data) {
      return data.map(item => ({
        id: item.Id,
        title: item.Adi,
        className: "bg-danger",
        start: new Date(item.Gun).getTime() + (3 * 60 * 60 * 1000),
        end: new Date(new Date(item.Gun).getTime() + (3 * 60 * 60 * 1000)).toISOString(),
      }));
    },
    dateClicked(info) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      var clickedDate = new Date(info.date)
      clickedDate.setHours(0, 0, 0, 0)

      if (clickedDate < today) {
        // return 
      }
      clickedDate = info.dateStr
      const calendarApi = info.view.calendar
      const events = calendarApi.getEvents()
      const hasEvent = events.some(ev => {
        return ev.startStr.startsWith(clickedDate)
      })

      if (hasEvent) {
        return
      }

      this.BaslangicTarih = info.date
      this.newEventData = info;
      this.DataUpdate = this.event
      this.AddEdit = 'Add'
    },

    editEvent(info) {
      this.edit = info.event;
      this.editevent.editTitle = this.edit.title;
      this.editevent.editcategory = this.edit.classNames[0];
      this.eventModal = true;
      this.DataUpdate = info.event.extendedProps.hamhali
      this.AddEdit = 'Edit'
    },




  },
  created() {

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar ref="fullCalendar" :options="calendarOptions"></FullCalendar>
            </div>
          </div>
        </div>
      </div>
    </div>


    <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get()"
      @ModalOpen="DataUpdate = null, AddEdit = null, Get()" :BaslangicTarih="BaslangicTarih" />
  </Layout>



</template>
